import React from 'react';
import PropTypes from 'prop-types';
import { Cardo } from '@cotyorg/ccx-organism-cardo';
import { getCardoConfig } from '../helpers';

const HalfCardo = ({
  index,
  cardoData,
  currentBreakpoint,
  baseBreakpointConfig,
  everyNthBreakpointConfig,
  ...rest
}) => {
  if (index % 2 === 0) {
    return (
      <Cardo
        data={cardoData}
        currentBreakpoint={currentBreakpoint}
        index={index}
        {...getCardoConfig({ baseBreakpointConfig, nthBreakpointConfig: everyNthBreakpointConfig[0] })}
        {...rest}
      />
    );
  }

  // index % 2 === 1
  return (
    <Cardo
      data={cardoData}
      currentBreakpoint={currentBreakpoint}
      index={index}
      {...getCardoConfig({ baseBreakpointConfig, nthBreakpointConfig: everyNthBreakpointConfig[1] })}
      {...rest}
    />
  );
};

HalfCardo.propTypes = {
  index: PropTypes.number.isRequired,
  cardoData: PropTypes.shape({
    tag: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
    label: PropTypes.string,
    averageRating: PropTypes.number,
    numberOfReviews: PropTypes.number,
    imageSrc: PropTypes.string.isRequired,
    imageSrcSet: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    })),
    alt: PropTypes.string,
  }),
  currentBreakpoint: PropTypes.string.isRequired,
  baseBreakpointConfig: PropTypes.objectOf(PropTypes.object),
  everyNthBreakpointConfig: PropTypes.arrayOf(PropTypes.object),
};

export default HalfCardo;
